import { DEFAULT_DESIGN_ID } from '../designs/catalog';
import type { Meta, Settings } from './schemas';

export function defaultSettings(): Settings {
  return {
    defaultDesignId: DEFAULT_DESIGN_ID,
    defaultFont: 'schoolbell',
    watermark: true,
    autoSize: true,
    compactDefault: false,
    completedBehavior: 'strike',
    quietHours: { enabled: false, start: '22:00', end: '07:00' },
    notificationsOptIn: false,
    history: { autoSnapshotMinutes: 10, maxPerNote: 50, maxAgeDays: 365 },
    favoriteDesigns: [],
    sort: 'updated',
    lockPreview: {
      wallpaper: 'tide',
      customWallpaperAssetId: null,
      position: 0.62,
      scale: 1,
      device: 'iphone-pro-max',
      contrast: false,
      showClock: true,
    },
    customFonts: [],
    installHintDismissed: false,
    deleteCheckedLines: false,
    showEmptyNotes: true,
    newPageTemplate: 'blank',
    tutorialSeen: false,
  };
}

export function defaultMeta(): Meta {
  return { firstUseAt: Date.now(), activeNoteId: null, lastSchedulerCheck: Date.now() };
}
